import styled from 'styled-components';

/**
 * A prominent, themed banner shown only in Customize mode so it's unmistakable that
 * the dashboard is editable (the toolbar toggle alone reads as a small gray chip).
 */
export const EditModeBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding: 10px 14px;
  border: 1px solid ${({ theme }) => theme.teal};
  border-radius: 8px;
  background: ${({ theme }) => theme.tealBackgroundColor};
  color: ${({ theme }) => theme.headerColor};
  font-size: 0.82rem;
  line-height: 1.4;

  .edit-mode-banner-icon {
    flex: 0 0 auto;
    color: ${({ theme }) => theme.teal};
    font-size: 1rem;
  }

  strong {
    font-weight: 600;
  }
`;

/**
 * Wraps the react-grid-layout container. WidthProvider measures this element, so
 * it must stretch to the available content width. Also restyles the drag
 * placeholder and the resize handle so they read clearly (the default
 * react-resizable handle is an almost-invisible dark grip) in both themes.
 */
export const DashboardGrid = styled.div`
  width: 100%;

  .react-grid-item.react-grid-placeholder {
    background: ${({ theme }) => theme.teal};
    opacity: 0.2;
    border-radius: 10px;
  }

  /* Visible teal corner grip for resizing (replaces the faint default SVG). */
  .react-resizable-handle {
    width: 22px;
    height: 22px;
    bottom: 0;
    right: 0;
    padding: 0;
    background: none;

    &::after {
      content: '';
      position: absolute;
      right: 5px;
      bottom: 5px;
      width: 9px;
      height: 9px;
      border-right: 2px solid ${({ theme }) => theme.teal};
      border-bottom: 2px solid ${({ theme }) => theme.teal};
      border-bottom-right-radius: 2px;
    }
  }
`;
